import React,{useEffect, useState} from "react"
import * as ReactDOM from "react-dom"
import {Grid, GridCellProps, GridColumn, GridColumnMenuCheckboxFilter} from "@progress/kendo-react-grid"
import {useAppDispatch, useAppSelector} from "../../store"
import {setMOTOpportunityDetail, setShowMotOpportunityDialog} from "../../containers/Activity/activitySlice"
import {RootState} from "../../rootReducer"
import {MotOpportunity} from "../../containers/Activity/models"
import {useInternationalization} from "@progress/kendo-react-intl"
import {SpinnerGrid} from "../../shared/CommonItems"
import {State, process} from "@progress/kendo-data-query"
import {columnProps} from "../../shared/ActiveGridFilter"
import {Tooltip} from "@progress/kendo-react-tooltip"

const OpportunitiesGrid = () => {
    const intl = useInternationalization()
    const dispatch = useAppDispatch()

    const data = useAppSelector((state: RootState) => state.containers.activity.motOpportunity)
    const loading = useAppSelector((state: RootState) => state.containers.activity.loading)

    const initialState: State = {skip: 0, take: 100}
    const [dataState, setDataState] = useState<State>(initialState)
    useEffect(() => {
        setDataState(initialState)
    }, [data])

    const formatDateCell = (props: GridCellProps) => {
        const dateVal =
            props.dataItem[`${props.field}`] == null || props.dataItem[`${props.field}`] === ""
                ? ""
                : intl.formatDate(new Date(props.dataItem[`${props.field}`]))
        return <td>{dateVal}</td>
    }

    const toggleMotOpportunityModel = (e: any, props: any) => {
        e.preventDefault()
        dispatch(setShowMotOpportunityDialog(true))
        dispatch(setMOTOpportunityDetail(props.dataItem))
    }

    const NameLinkCell = (props: any) => (
        <td className="k-grid-content-sticky" style={{left: "0px"}}>
            <a
                href=" "
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                onClick={event => toggleMotOpportunityModel(event, props)}
            >
                {props.dataItem.registration}
            </a>
        </td>
    )
    const CustomColumnCell = (props: GridCellProps) => (
        <td
            style={props.style}
            className={`${props.className}`}
            colSpan={props.colSpan}
            role={"gridcell"}
            title={props.dataItem[`${props.field}`]}
        >
            {props.dataItem[`${props.field}`]}
        </td>
    )
    return (
        <div className="position-relative">
            {loading && <SpinnerGrid />}
            <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
                <Grid
                    style={{height: "calc(100vh - 15.6rem)"}}
                    data={process(data, dataState)}
                    {...dataState}
                    pageable
                    sortable
                    onDataStateChange={event => setDataState(event.dataState)}
                >
                    <GridColumn
                        {...columnProps("registration", dataState)}
                        field="registration"
                        title="VehRegNo"
                        cell={props => <NameLinkCell {...props} />}
                        locked
                    />
                    <GridColumn
                        {...columnProps("customerName", dataState)}
                        field="customerName"
                        cell={CustomColumnCell}
                        title="Name"
                    />
                    <GridColumn
                        {...columnProps("phone", dataState)}
                        field="phone"
                        title="Phone"
                        cell={CustomColumnCell}
                    />
                    <GridColumn
                        {...columnProps("email", dataState)}
                        field="email"
                        title="Email"
                        cell={CustomColumnCell}
                    />
                    <GridColumn
                        {...columnProps("motExpiryDate", dataState)}
                        field="motExpiryDate"
                        filter="date"
                        cell={formatDateCell}
                        title="Expiry Date"
                    />
                    <GridColumn
                        {...columnProps("followUpStatus", dataState)}
                        columnMenu={props => <GridColumnMenuCheckboxFilter {...props} data={data} expanded={true} />}
                        field="followUpStatus"
                        title="Follow Up Status"
                    />
                </Grid>
            </Tooltip>
        </div>
    )
}
export default OpportunitiesGrid
